import { useEffect, useRef, useCallback } from 'react';

const INACTIVITY_MS = 30 * 60 * 1000;
const WARNING_MS   = 2 * 60 * 1000;
const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

export function useSessionTimeout({ onLogout, enabled = true }) {
    const logoutTimer  = useRef(null);
    const warnTimer    = useRef(null);
    const warnShown    = useRef(false);

    const clearTimers = useCallback(() => {
        clearTimeout(logoutTimer.current);
        clearTimeout(warnTimer.current);
    }, []);

    const startTimers = useCallback(() => {
        clearTimers();
        warnShown.current = false;

        warnTimer.current = setTimeout(() => {
            if (warnShown.current) return;
            warnShown.current = true;
            const extend = window.confirm(
                'Sua sessão vai expirar em 2 minutos por inatividade.\nDeseja continuar conectado?'
            );
            if (extend) {
                startTimers();
            }
        }, INACTIVITY_MS - WARNING_MS);

        logoutTimer.current = setTimeout(() => {
            onLogout();
        }, INACTIVITY_MS);
    }, [clearTimers, onLogout]);

    const reset = useCallback(() => {
        if (!enabled) return;
        startTimers();
    }, [enabled, startTimers]);

    useEffect(() => {
        if (!enabled) return;

        startTimers();

        EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));

        return () => {
            clearTimers();
            EVENTS.forEach((e) => window.removeEventListener(e, reset));
        };
    }, [enabled, reset, startTimers, clearTimers]);
}
